import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SourceTypeSidebarComponent } from '../source-type-sidebar/source-type-sidebar.component';
import { TemplateListPanelComponent } from '../template-list-panel/template-list-panel.component';
import { TemplateRulesPanelComponent } from '../template-rules-panel/template-rules-panel.component';

/**
 * Three-pane shell for the "Rules by Template" tab.
 *
 * Composes the SourceTypeSidebar (left), TemplateListPanel (middle), and
 * TemplateRulesPanel (right). All state — source-type selection, template
 * selection, rule lists — is owned by the NgRx store via ValidationRulesFacade,
 * so the panels are stateless w.r.t. each other.
 */
@Component({
  selector: 'app-rules-by-template-tab',
  standalone: true,
  imports: [
    CommonModule,
    SourceTypeSidebarComponent,
    TemplateListPanelComponent,
    TemplateRulesPanelComponent,
  ],
  templateUrl: './rules-by-template-tab.component.html',
})
export class RulesByTemplateTabComponent {}
